import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getCurrentDate } from "../utils/currentDate";

const targetDate = new Date("2025-08-01T04:00:00Z"); // 12:00am EST is 4:00am UTC

const AugustCountdownPage: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  function getTimeLeft() {
    const now = getCurrentDate();
    const diff = targetDate.getTime() - now.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);
    return { days, hours, minutes, seconds, diff };
  }

  useEffect(() => {
    const timer = setInterval(async () => {
      const updated = getTimeLeft();
      setTimeLeft(updated);

      // When countdown is done, update isAugust in Firestore
      if (updated.diff <= 0) {
        const auth = getAuth();
        const user = auth.currentUser;
        if (user) {
          const userRef = doc(db, "users", user.uid);
          await updateDoc(userRef, { isAugust: true });
        }
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="day-page">
      <h1>Countdown to August!</h1>
      <div style={{ fontSize: "2rem", fontWeight: "bold", color: "#0288d1", margin: "30px 0" }}>
        {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
      </div>
      <p>This will unlock on August 1st, 2025 at 12:00am EST.</p>
    </div>
  );
};

export default AugustCountdownPage;